let FreeNodeCheckPointDirection = {
    Unknown :0,
    Left :1,
    Top :2,
    Rigth :3,
    Bottom :4,
    Vertical_Center :5,
    Horizontal_Center :6,
}
export default FreeNodeCheckPointDirection